import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ITeamBookingOverviewQuery } from '../interfaces/team-booking-overview.query.interface';
import { TeamBookingOverview } from '../models/team-booking-overview.model';

@Injectable()
export class TeamBookingOverviewApiService {
    constructor(private _http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private _environment: IEnvironment) {}

    getTeamBookingOverview(teamId: string, includeSubteams: boolean = true): Observable<TeamBookingOverview> {
        const params = new HttpParams().set('includeSubteams', includeSubteams.toString());

        return this._http
            .get<ITeamBookingOverviewQuery>(`${this._environment.apiUrl}/teams/${teamId}/booking-overview`, { params })
            .pipe(map((query) => new TeamBookingOverview(query)));
    }

    getTeamMemberBookingOverview(teamId: string, userId: string): Observable<TeamBookingOverview> {
        return this._http
            .get<ITeamBookingOverviewQuery>(`${this._environment.apiUrl}/teams/${teamId}/users/${userId}/booking-overview`)
            .pipe(map((query) => new TeamBookingOverview(query)));
    }
}
